// 👇 Reactstrap Imports
import { Row, Col, Carousel, CarouselItem, CarouselControl, Card, CardTitle, CardBody } from 'reactstrap'
import { useEffect, useState } from 'react'
import { getAllDataSummaryStats, SignalRBuilder } from '../../apps/reports/store'
import { isValidToken } from '../../pages/account-settings/store'
import { putRefreshToken } from '../customerDashboard/store'
import toast from 'react-hot-toast'
import { BarChartLoader } from '@components/content-loader'

// 👇 Custom Components
import CustomDataDisplayChart from './components/CustomDataDisplayChart'
import InboundStats from './components/InboundStats'
import InboundChart from './components/InboundChart'
import InboundStatsVertical from './components/InboundStatsVertical'
import FFStatsCard from './components/FFStatsCard'
import FFAlerts from './components/FFAlerts'
import { useDispatch } from 'react-redux'
import { getFFDashboardAlert } from '../ffdashboard/store'

const TVDashboard = () => {
  const [loading, setLoading] = useState(false)
  const [dataReport, setDataReport] = useState({
    counters: [
      {
        bagmt: 0,
        bgrmt: 0,
        blkmt: 0,
        totalContainer: 0,
        totalMT: 0,
        totalUnits: 0
      }
    ],
    unitsPerType: [
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        type: "HOPPER"
      },
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        type: "IMDL"
      },
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        type: "BOX"
      }
    ],
    unitsPerYard: [
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        yard: "LINDSEY"
      },
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        yard: "KINGSWAY"
      },
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        yard: "EWEN"
      },
      {
        bagUnits: 0,
        baggerUnits: 0,
        bulkUnits: 0,
        total: 0,
        yard: "TBD"
      }
    ]
  })

  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const dispatch = useDispatch()

  const checkUserToken = async () => {
    const res = await isValidToken()
    if (!res.success) {
      const token = await putRefreshToken({
        accessToken: localStorage.getItem('accessToken'),
        refreshToken: localStorage.getItem('refreshToken')
      })
      console.log(token) // Currently not implemented
    }

    console.log(loading)
    console.log(dataReport)
  }

  // Fetch Data Summay Stats
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await getAllDataSummaryStats()
        setDataReport(res.data)
      } catch (error) {
        console.error("Error fetching data summary stats: ", error)
        toast.error("Error fetching data summary stats")
      }
      setLoading(false)
    }
    fetchData()
  }, [])

  useEffect(() => {
    const connection = SignalRBuilder()
    connection.start()
      .then(() => {

        // Handle Data Summary Report Stats
        connection.on('DataSummaryReport', (message) => {
          checkUserToken() // Check if token is expired, and refreshes if needed
          if (message) {
            // toast promise
            toast.promise(
              new Promise((resolve) => {
                setLoading(true)
                setDataReport(message)

                setTimeout(() => {
                  setLoading(false)
                  resolve()
                }, 500)
              }),
              {
                loading: 'Updating Data Summary Report...',
                success: 'Data Summary Report Updated!',
                error: 'Failed to update Data Summary Report'
              },
              {
                position: 'top-right'
              }
            )
          }
        })
      })
      .catch((err) => console.error('Connection failed:', err))

    return () => {
      connection.off('DataSummaryReport')

      connection.stop()
        .then(() => console.log('Disconnected from SignalR Hub'))
        .catch((error) => console.error('Disconnection failed: ', error))
    }
  }, [])

  useEffect(() => {
    dispatch(getFFDashboardAlert())
  }, [])

  // ** Carousel Slide Definitions
  const slides = [
    {
      key: 1,
      content: (
        <Row style={{ height: '100%' }}>
          {/* "TEST" Column */}
          <Col
            xl='4'
            style={{
              display: 'flex',
              borderRadius: '15px', // Rounded corners
              height: '100%' // Ensures it spans the full height
            }}
          >
            <InboundStatsVertical
              cols={{ xl: '12', md: '12', sm: '12' }} // Adjust cols if necessary
              data={dataReport.counters[0]}
              loading={loading}
              style={{
                flex: 1,
                borderRadius: '15px', // Rounded corners
                backgroundColor: '#ffffff',
                padding: '1rem',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
            />
          </Col>

          {/* Right Column containing InboundStats and CustomDataDisplayChart */}
          <Col xl='8' style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <FFStatsCard
              cols={{ xl: '3', sm: '6' }}
              data={new Array(4).fill({})}
            />

            {/* InboundStats Component */}
            {/* <InboundStats
              cols={{ xl: '2', md: '4', sm: '4' }}
              data={dataReport.counters[0]}
              loading={loading}
              style={{
                flex: 1,
                borderRadius: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
            /> */}

            <Card className='mt-n3'>
              <CardBody color='primary'>
                <h5> ShipSmpl Dashboard </h5>
              </CardBody>
            </Card>

            {/* CustomDataDisplayChart Component */}
            <CustomDataDisplayChart
              data={dataReport}
              loading={loading}
              style={{
                flex: 1,
                borderRadius: '15px',
                padding: '1rem',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
            />
          </Col>
        </Row>
      )
    },
    {
      key: 2,
      content: (
        <Row className='match-height'>
          <Col xl='6' lg='6' md='12'>
            {loading ? <BarChartLoader /> : <InboundChart title='Units Per Type' data={dataReport.unitsPerType} />}
          </Col>
          <Col xl='6' lg='6' md='12'>
            {loading ? <BarChartLoader /> : <InboundChart title='Units Per Type' data={dataReport.unitsPerType} />}
          </Col>
        </Row>
      )
    },
    {
      key: 3,
      content: (
        <Row className='match-height'>
          <Col xl='12'>
            <FFAlerts />
          </Col>
        </Row>
      )
    }
  ]

  // Carousel Handlers
  const next = () => {
    if (animating) return
    const nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  // Autoplay Carousel Setup
  useEffect(() => {
    const interval = setInterval(() => {
      if (!animating) {
        next()
      }
    }, 100000)

    return () => clearInterval(interval)
  }, [activeIndex, animating])

  return (
    <div id='app-user-list' className='pt-[10%] bg-white' style={{ width: '1920px', height: '1080px', margin: '0 auto', overflow: 'hidden' }}>
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        ride="carousel"
        interval={10000}
        slide={false}
      >
        {slides.map((slide) => (
          <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={slide.key}
          >
            {slide.content}
          </CarouselItem>
        ))}
        <CarouselControl direction='prev' directionText='Previous' onClickHandler={previous} />
        <CarouselControl direction='next' directionText='Next' onClickHandler={next} />
      </Carousel>

      <div className='text-end text-muted'>Last Updated: {new Date().toLocaleTimeString()}</div>
    </div>
  )
}

export default TVDashboard
